<template>
  <!-- eslint-disable max-len -->
  <svg
    width="60px"
    height="60px"
    viewBox="0 0 64 64"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Family</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <polygon
        points="0.0446511628 0.498261181 63.4939535 0.498261181 63.4939535 63.0153846 0.0446511628 63.0153846"
      />
    </defs>
    <g
      stroke="none"
      stroke-width="1"
      fill="#999999"
      fill-rule="evenodd"
    >
      <g>
        <g>
          <mask
            fill="white"
          >
            <use
              xlink:href="#path-1"
            />
          </mask>
          <g />
          <path
            d="M31.7469767,0.498261181 C14.2132093,0.498261181 0,14.4928057 0,31.7568229 C0,49.0208401 14.2132093,63.0153846 31.7469767,63.0153846 C49.2822326,63.0153846 63.4939535,49.0208401 63.4939535,31.7568229 C63.4939535,14.4928057 49.2822326,0.498261181 31.7469767,0.498261181 M31.7469767,5.91611878 C46.2191628,5.91611878 57.9906977,17.5087513 57.9906977,31.7568229 C57.9906977,46.0048945 46.2191628,57.5960615 31.7469767,57.5960615 C17.2777674,57.5960615 5.50325581,46.0048945 5.50325581,31.7568229 C5.50325581,17.5087513 17.2777674,5.91611878 31.7469767,5.91611878"
            fill="#999999"
            mask="url(#mask-2)"
          />
        </g>
        <path
          d="M36.4368372,39.5560758 L34.1722791,36.652239 C35.2193488,35.7429123 35.9821395,35.537746 36.8275349,35.169912 L36.8275349,34.2576544 L41.0612093,34.2576544 L41.0612093,38.0715506 L39.7916279,38.2796479 C37.6989767,38.5705445 37.1140465,38.967688 36.4368372,39.5560758"
          fill="#999999"
        />
        <path
          d="M56.7493953,45.479522 L53.8173023,46.7207785 C53.8753488,46.1814841 54.1596279,39.7605095 47.8586047,38.2474075 L46.9871628,37.9315979 L46.9871628,34.2576544 L49.5270698,34.2576544 L49.5270698,35.3186576 C55.4530233,37.4641116 57.0842791,42.8042991 56.7493953,45.479522"
          fill="#999999"
        />
        <path
          d="M49.2011163,36.5437939 L46.9856744,34.2576544 C48.2552558,32.8867034 49.312,29.2076308 49.312,27.4182869 C49.312,23.8381338 46.9551628,20.9255041 44.0587907,20.9255041 C41.1616744,20.9255041 38.8055814,23.8381338 38.8055814,27.4182869 C38.8055814,29.1731921 39.9583256,32.9621753 41.0604651,34.2576544 L38.1700465,36.9064987 C36.7702326,35.2644351 35.3495814,30.2451864 35.3495814,27.4182869 C35.3495814,21.962327 39.2565581,17.5226733 44.0587907,17.5226733 C48.8602791,17.5226733 52.7672558,21.962327 52.7672558,27.4182869 C52.7672558,30.4562147 50.6783256,34.9478927 49.2011163,36.5437939"
          fill="#999999"
        />
        <path
          d="M6.35609302,46.7207785 C6.26902326,43.5260451 8.32818605,37.1299835 16.4978605,34.704624 L16.4941395,33.132903 L19.9501395,33.1233775 L19.9605581,37.3703213 L18.6143256,37.6729417 C9.72725581,39.6711156 9.80837209,46.5632401 9.81060465,46.6335828 L6.35609302,46.7207785"
          fill="#999999"
        />
        <path
          d="M22.5704186,13.349736 C16.9495814,13.349736 12.3795349,18.5646254 12.3795349,24.9738762 C12.3795349,28.3759742 14.8792558,33.2845796 16.7114419,35.4080515 L19.8556279,33.1277739 C18.4692093,31.4651936 15.959814,27.2534211 15.959814,24.9738762 C15.959814,20.5093095 18.9253953,16.8763993 22.5704186,16.8763993 C26.2154419,16.8763993 29.1802791,20.5093095 29.1802791,24.9738762 C29.1802791,26.9537317 27.5668837,30.9530104 26.2556279,32.8339463 L29.9929302,32.8449374 C31.2766512,31.3032587 32.7613023,28.7115678 32.7613023,24.9738762 C32.7613023,18.5646254 28.1912558,13.349736 22.5704186,13.349736"
          fill="#999999"
        />
        <path
          d="M22.4342326,57.5960615 L19.048186,57.5960615 L19.048186,52.8618476 C19.048186,50.6870841 20.7412093,46.2393703 24.9741395,44.4375699 L24.9741395,43.8337946 L28.4234419,43.8257345 L28.4271628,47.0768887 L27.3428837,47.3795091 C22.184186,48.5386991 22.4342326,52.3577245 22.4342326,52.7907721 L22.4342326,57.5960615"
          fill="#999999"
        />
        <path
          d="M38.6143256,57.9895413 L38.5406512,52.7731864 L38.5525581,52.6647413 C38.5897674,52.275658 38.7810233,48.6537388 33.6267907,47.5136 L32.3423256,47.2278326 L32.1934884,44.1884394 L35.6450233,44.025039 L35.6710698,44.5408859 C41.1140465,46.301653 42.2154419,50.6460508 41.9988837,52.9380522 L42.0695814,57.9426462 L38.6143256,57.9895413"
          fill="#999999"
        />
        <path
          d="M26.2243721,45.774815 C24.9778605,44.4302426 23.1702326,40.9702583 23.1702326,38.6071814 C23.1702326,34.2525252 26.292093,30.7119399 30.1276279,30.7119399 C33.8567442,30.7119399 36.8461395,34.0737374 37.0820465,38.533175 C37.1795349,40.3335098 36.392186,42.7053796 34.7430698,45.5828379 L32.2344186,44.1884394 C34.039814,41.0420665 34.2466977,39.3875463 34.208,38.6819206 C34.0517209,35.7546361 32.2969302,33.5476322 30.1276279,33.5476322 C27.8794419,33.5476322 26.0509767,35.8169188 26.0509767,38.6071814 C26.0509767,40.1092923 27.4634419,42.9054168 28.3527442,43.8623714 L26.2243721,45.774815"
          fill="#999999"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgFamily',
};
</script>
